import { gql } from '@apollo/client/core';
import DealPreview from '~/apollo/fragments/Deal/DealPreview.fragment';

export const PortfolioCurrentUserDealsSummaryQuery = gql`
  query CurrentUserDealsSummary {
    portfolioCurrentUser {
      id
      topDeals {
        nodes {
          id
          amount
          isPrivateCompany
          company {
            id
            name
          }
        }
      }
    }
  }
`;

export const PortfolioCurrentUserDealsQuery = gql`
  ${DealPreview}
  query PortfolioCurrentUserDeals {
    portfolioCurrentUser {
      id
      dealQuarters {
        year
        quarter
        quota
        revenue
      }
      deals {
        nodes {
          ...DealPreview
        }
      }
    }
  }
`;
